import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-options-strings';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { DetailsList, SelectionMode, DetailsListLayoutMode, ColumnActionsMode, CheckboxVisibility, } from 'office-ui-fabric-react/lib/DetailsList';
import { ActionButton, IconButton, ButtonType } from 'office-ui-fabric-react/lib/Button';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { Selection } from 'office-ui-fabric-react/lib/Selection';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { connectedAccountsStore } from '../store/store';
import { getSelectedAccount } from '../selectors/getSelectedAccount';
import { selectConnectedAccount } from '../actions/connectedFull/selectConnectedAccount';
import { deleteConnectedAccount } from '../actions/connectedFull/deleteConnectedAccount';
import { resetConnectGmailStore } from '../actions/connectGmail/resetConnectGmailStore';
import { toggleConnectGmailWindow } from '../actions/connectGmail/toggleConnectGmailWindow';
import { resetConnectBasicStore } from '../actions/connectBasic/resetconnectBasicStore';
import { toggleConnectBasicWindow } from '../actions/connectBasic/toggleconnectBasicWindow';
import { resetEditAccountStore } from '../actions/editAccount/resetEditAccountStore';
import { selectDefaultFromAddress } from '../actions/defaultFrom/selectDefaultFromAddress';
import { markIsConnectedAccountsDirty } from '../actions/connectedFull/markIsConnectedAccountsDirty';
import { markIsDefaultFromDirty } from '../actions/connectedFull/markIsDefaultFromDirty';
import { loadMrsConnectedAccounts } from '../utils/loadMrsConnectedAccounts';
import EditButton from './EditButton';
import ConnectGmailWindow from './ConnectGmailWindow';
import ConnectBasicWindow from './ConnectBasicWindow';
import ConnectAdvancedWindow from './ConnectAdvancedWindow';
import ConnectedAccountEditor from './ConnectedAccountEditor';
var styles = require('./ConnectedAccountsFull.scss');
var spriteStyles = require('owa-sprite/dist/styles/mail_sprite.css');
var classNames = require('classnames/bind');
var MAX_ALLOWED_ACCOUNTS = 20;
var MANAGE_ACCOUNT_URL = 'https://account.live.com/names/Manage';
var ConnectedAccountsFull = /** @class */ (function (_super) {
    tslib_1.__extends(ConnectedAccountsFull, _super);
    function ConnectedAccountsFull(props) {
        var _this = _super.call(this, props) || this;
        _this.onAccountSelected = function (index) {
            selectConnectedAccount(index);
            var selected = getSelectedAccount();
            if (selected) {
                var syncRequest = selected.syncRequest;
                resetEditAccountStore(syncRequest);
            }
        };
        _this.onAccountDeselected = function () {
            var selected = getSelectedAccount();
            if (selected) {
                selectConnectedAccount(-1);
            }
        };
        _this.onSelectionChanged = function () {
            var selectedIndices = _this.selection.getSelectedIndices();
            if (selectedIndices.length > 0) {
                _this.onAccountSelected(selectedIndices[0]);
            }
            else {
                _this.onAccountDeselected();
            }
        };
        _this.getKey = function (item, index) {
            return index;
        };
        _this.onGmailClicked = function () {
            resetConnectGmailStore();
            toggleConnectGmailWindow({ connectGmailOpen: true });
        };
        _this.onOtherClicked = function () {
            resetConnectBasicStore();
            toggleConnectBasicWindow({ connectBasicOpen: true });
        };
        _this.onDefaultFromAddressChanged = function (address) {
            if (address) {
                selectDefaultFromAddress(address.text);
                markIsDefaultFromDirty(true);
            }
        };
        _this.onEmailAliasClicked = function () {
            window.location.href = MANAGE_ACCOUNT_URL;
        };
        _this.onDeleteClicked = function () {
            var store = connectedAccountsStore();
            if (store.selected >= 0) {
                deleteConnectedAccount(store.selected);
                markIsConnectedAccountsDirty(true);
            }
        };
        _this.onRenderRow = function (props, defaultRender) {
            if (defaultRender) {
                return React.createElement("div", { className: styles.row }, defaultRender(props));
            }
            return null;
        };
        _this.onRenderItemColumn = function (item, index, column) {
            if (column.key === 'command') {
                return (React.createElement("div", { className: styles.commandCol },
                    React.createElement(EditButton, { onSelected: _this.onAccountSelected, index: index }),
                    React.createElement(IconButton, { buttonType: ButtonType.command, onClick: _this.onDeleteClicked, iconProps: { iconName: "Delete" /* Delete */ }, className: styles.command, title: strings.options_connected_full_deleteButton }),
                    React.createElement(IconButton, { buttonType: ButtonType.command, onClick: loadMrsConnectedAccounts, iconProps: { iconName: "Refresh" /* Refresh */ }, className: styles.command, title: strings.options_connected_full_refreshButton })));
            }
            return item[column.key];
        };
        _this.selection = new Selection({
            onSelectionChanged: _this.onSelectionChanged,
            getKey: _this.getKey,
        });
        return _this;
    }
    Object.defineProperty(ConnectedAccountsFull.prototype, "columns", {
        get: function () {
            return [
                {
                    key: 'accountName',
                    fieldName: 'accountName',
                    name: strings.options_connected_full_accountColumn,
                    minWidth: 150,
                    maxWidth: 300,
                    isResizable: false,
                    columnActionsMode: ColumnActionsMode.disabled,
                },
                {
                    key: 'lastUpdate',
                    fieldName: 'lastUpdate',
                    name: strings.options_connected_full_lastUpdateColumn,
                    minWidth: 150,
                    maxWidth: 250,
                    isResizable: false,
                    columnActionsMode: ColumnActionsMode.disabled,
                },
                {
                    key: 'command',
                    fieldName: 'command',
                    name: '',
                    minWidth: 150,
                    maxWidth: 250,
                    isResizable: false,
                    columnActionsMode: ColumnActionsMode.disabled,
                },
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedAccountsFull.prototype, "emailAddressOptions", {
        get: function () {
            var store = connectedAccountsStore();
            return store.defaultFromState.emailAddresses;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedAccountsFull.prototype, "defaultSelectedAddress", {
        get: function () {
            var store = connectedAccountsStore();
            for (var _i = 0, _a = store.defaultFromState.emailAddresses; _i < _a.length; _i++) {
                var address = _a[_i];
                if (address.text === store.defaultFromState.defaultFromAddress) {
                    return address.key.toString();
                }
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    ConnectedAccountsFull.prototype.render = function () {
        var accounts = connectedAccountsStore().accounts;
        return (React.createElement("div", null,
            React.createElement(ConnectGmailWindow, null),
            React.createElement(ConnectBasicWindow, null),
            React.createElement(ConnectAdvancedWindow, null),
            React.createElement(ConnectedAccountEditor, null),
            React.createElement("div", { className: styles.section },
                React.createElement("div", null, format(strings.options_connected_full_addAccountTitle, MAX_ALLOWED_ACCOUNTS)),
                React.createElement(Label, { className: styles.title }, strings.options_connected_full_addAccountLabel),
                React.createElement("div", { className: styles.actionButton },
                    React.createElement("span", { className: classNames([
                            spriteStyles['mail-icon-connectgmail'],
                            styles.actionIcon,
                        ]) }),
                    React.createElement(ActionButton, { buttonType: ButtonType.command, onClick: this.onGmailClicked, className: styles.addAccountCommand, disabled: accounts.length >= MAX_ALLOWED_ACCOUNTS }, strings.options_connected_full_connectGmailButton)),
                React.createElement("div", { className: styles.actionButton },
                    React.createElement("span", { className: classNames([
                            spriteStyles['mail-icon-connectothermail'],
                            styles.actionIcon,
                        ]) }),
                    React.createElement(ActionButton, { buttonType: ButtonType.command, onClick: this.onOtherClicked, className: styles.addAccountCommand, disabled: accounts.length >= MAX_ALLOWED_ACCOUNTS }, strings.options_connected_full_otherAccountsButton))),
            React.createElement("div", { className: styles.section },
                React.createElement(Label, { className: styles.title }, strings.options_connected_full_manageAccountLabel),
                React.createElement(DetailsList, { className: styles.list, items: accounts, columns: this.columns, selection: this.selection, selectionMode: SelectionMode.single, layoutMode: DetailsListLayoutMode.justified, selectionPreservedOnEmptyClick: true, checkboxVisibility: CheckboxVisibility.hidden, onRenderRow: this.onRenderRow, onRenderItemColumn: this.onRenderItemColumn })),
            React.createElement("div", { className: styles.section },
                React.createElement(Label, { className: styles.title }, strings.options_connected_full_changeFromAddressLabel),
                React.createElement(Dropdown, { className: styles.defaultFrom, onChanged: this.onDefaultFromAddressChanged, options: this.emailAddressOptions, selectedKey: this.defaultSelectedAddress })),
            React.createElement("div", { className: styles.section },
                React.createElement(Label, { className: styles.title }, strings.options_connected_full_emailAliasesLabel),
                React.createElement(Link, { onClick: this.onEmailAliasClicked }, strings.options_connected_full_manageEmailAliasLink))));
    };
    ConnectedAccountsFull = tslib_1.__decorate([
        observer
    ], ConnectedAccountsFull);
    return ConnectedAccountsFull;
}(React.Component));
export default ConnectedAccountsFull;
//# sourceMappingURL=ConnectedAccountsFull.js.map